var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('interface-modal',{attrs:{"modal-open":_vm.showModal},on:{"closeModal":function($event){_vm.showModal = false}}},[_c('code',[_vm._v(_vm._s(_vm.errorMessage))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }